(function () {
  rbxCustomRedirect();
})();

/*
document.addEventListener("DOMContentLoaded", function () {
  rbxCustomRedirect();
});
*/
function rbxCustomRedirect(){


    // Read the cookie
  var token = getCookie("invitation");

    // 🔥 1. Skip everything if in Shopify theme editor or preview or token is good
  if (isShopifyPreview() || token) {
    // If cookie exists, remove 'invitation-block' class from body
    document.addEventListener("DOMContentLoaded", function () {
      document.body.classList.remove("invitation-block");
    });
  } else {
    // Otherwise, redirect to invitation page
    window.location.href = "https://invitation.odettehome.com";
  }
}

  // Helper: read cookie value by name
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Helper: detect Shopify editor / preview
function isShopifyPreview() {
  // Case 1 → Theme Editor
  if (window.Shopify && Shopify.designMode) return true;

  // Preview parameters Shopify uses
  const previewParams = ["preview_theme_id", "oseid", "_ab"];

  // Check querystring for any preview parameter
  for (const p of previewParams) {
    if (location.search.includes(p + "=")) return true;
  }

  return false;
}